import { gql } from 'graphql-request';

import { graphQLFragments } from 'shared/graphql/fragments';

const checkoutDetails = gql`
  ${graphQLFragments.checkoutSummaryShape}
  ${graphQLFragments.audiobookShape}
  query CheckoutDetailsQuery($audiobookIds: [ID!], $promoCodeName: String, $useGiftCards: Boolean, $isGiftPurchase: Boolean) {
    checkoutDetails(audiobookIds: $audiobookIds, promoCodeName: $promoCodeName, useGiftCards: $useGiftCards, isGiftPurchase: $isGiftPurchase) {
      checkoutSummary {
        ...checkoutSummaryFields
      }
      audiobooks {
        ...audiobookFields
        bookDescription
        bookDescriptionShort
        editorialDescription
        deletedForCurrentUser
        matchesCurrentUserExistingTitle
        priceWhenAddedToCurrentUserCart
        runtime
        currentProduct {
          discountPrice
          discountedPriceCents
          id
          isFreeListing
          listingPrice
          timeLeft
          showListingPrice
        }
      }
    }
  }
`;

const currentUserShoppingCart = gql`
  ${graphQLFragments.checkoutSummaryShape}
  ${graphQLFragments.shoppingCartItemShape}
  query CurrentUserShoppingCartQuery($promoCodeName: String, $useGiftCards: Boolean) {
    currentUserShoppingCart(promoCodeName: $promoCodeName, useGiftCards: $useGiftCards) {
      shoppingCartItems {
        ...shoppingCartItemFields
      }
      checkoutSummary {
        ...checkoutSummaryFields
      }
    }
  }
`;

export const shoppingCartQueries = {
  currentUserShoppingCart,
  checkoutDetails,
};
